<div class="form-row">
  <div class="col-12">
    <app-entity-unify-update
      [isShowCard]="false"
      [isOnlyEdit]="true"
      [entity]="entity"
      [code]="entityCode"
      [formGroup]="fg"
      [errors]="errors"
    ></app-entity-unify-update>
  </div>
</div>
